module.exports = __webpack_public_path__ + "static/media/gh9.1fc596d6.png";